module.exports = __webpack_public_path__ + "static/media/california-ortho-and-spine-logo-new@3x.c170a46a.png";